import type { NAuth } from '@app/types/Auth';

export namespace NFunnels {
  export type SalesFunnelFilterDto = {
    Id: number;
    Name: string | null;
    Stages: SalesFunnelStageFilterDto[] | null;
  };

  export type SalesFunnelStageFilterDto = {
    Id: number;
    Name: string | null;
    Color: string | null;
  };

  export type SalesFunnelListDto = {
    Id: number;
    Name: string | null;
    Description: string | null;
    Stages: SalesFunnelStageFilterListDto[];
    CountUnreadLogs: number | null;
  };

  export type SalesFunnelStageFilterListDto = {
    Id: number;
    Name: string | null;
    Color: string | null;
    Category: number;
    Order: number;
    Description: string | null;
  };

  export type SalesFunnelStageDto = {
    Id: number;
    Name: string | null;
    Color: string | null;
    Category: number;
    Order: number;
    Description: string | null;
  };

  export type CreateSalesFunnelStageDto = {
    SalesFunnelId: number;
    Name: string | null;
    Color: string | null;
    Category: number;
    Order: number;
    Description: string | null;
    ActiveBranchId: NAuth.UserPrint['activeBranchId'];
  };

  export type UpdateSalesFunnelStageDto = {
    Name: string | null;
    Color: string | null;
    Category: number;
    Order: number;
    Description: string | null;
  };

  export type SalesFunnelDto = {
    Name: string | null;
    Description: string | null;
    UseAutoStageSwitch: boolean;
    ClientServices: number[];
    Id: number;
  };

  export type SalesFunnelStageListDto = {
    Id: number;
    Name: string | null;
    Color: string | null;
    Category: number;
    Order: number;
    Leads?: SalesFunnelLeadDto[] | null;
    Robots?: SalesFunnelRobotDto[] | null;
    Description: string | null;
    CountLeads: number;
  };

  export type SalesFunnelLeadDto = {
    Id: number;
    ClientName: string | null;
    ClientId: number | null;
    ClientPhoto: string | null;
    LastMessage: string | null;
    SocialIntegrationType: string | null;
  };

  export type SalesFunnelRobotDto = {
    Id: number;
    RobotTypeName: string;
    TriggerType: string;
    TriggerInfo: Record<
      string,
      Array<string> | Array<number> | number | string | boolean
    > | null;
    Comment: string | null;
    CountUnreadLogs: number | null;
    Type: 1 | 2 | 3 | 4 | 5 | 6 | 100;
  };

  export type WriteSalesFunnelDto = {
    Name: string | null;
    Description: string | null;
    UseAutoStageSwitch: boolean;
    SyncStagesInExistedLeads: boolean;
    ClientServices: number[];
  };

  export type RobotTaskGroupProgressEventType = {
    hasErrors: boolean;
    progress: number;
    robotId: number;
  };
  export interface UpdateStageForLeadRequest {
    UserId: NAuth.UserPrint['userId'];
    Database: NAuth.UserPrint['database'];
    ActiveBranchId: NAuth.UserPrint['activeBranchId'];
    leadId: number;
    newFunnelStageId: number;
  }
  export interface DeleteStageForLeadRequest {
    UserId: NAuth.UserPrint['userId'];
    Database: NAuth.UserPrint['database'];
    ActiveBranchId: NAuth.UserPrint['activeBranchId'];
    leadId: number;
    funnelStageId: number;
  }

  export interface AddStageForLeadRequest {
    ActiveBranchId: NAuth.UserPrint['activeBranchId'];
    leadId: number;
    funnelStageId: number;
  }

  export interface SalesFunnelStageFilterItemDto {
    Id: number | null;
    Title: string | null;
  }
}
